// extracted by mini-css-extract-plugin
export default {"propertyInformationBox":"styles_propertyInformationBox__4-fyR"};